export const pkg = {
  name: 'isomorphic-git',
  version: '1.36.2',
  agent: 'git/isomorphic-git@1.36.2',
}
